import React from 'react';
import { InputLabel } from './styles';

export default function Label({ title, color }) {
  return <>{title && <InputLabel color={color}>{title}</InputLabel>}</>;
}
